var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widgetUrl !== null)?_c('div',{staticClass:"overlay-container"},[_c('div',{staticClass:"dashed-border iframe-container",attrs:{"id":"overlay","allowfullscreen":""}},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.widgetUrl,"title":"MX Connect Widget","frameborder":"0","id":"mxiframe"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }